<div class="x-icon" (click)="closeMenu()">X</div>
<div class="search-button" (click)="updateOffersOnClose()">{{'SEARCH' | translate | uppercase}}</div>
<div class="card-header">{{'FILTER' | translate}}</div>
<div class="filter-container" *ngIf="fts.allOffers && fts.allOffers.length > 0">
  <div class="left-container">
    <div class="types-container">
      <div class="subtitle">{{fts.typeField.value | translatedb}}</div>
      <div class="types-selection">
        <div class="left">
          <div *ngFor="let type of fts.types" (click)="fts.selectOfferType(type)"
               [ngClass]="{'selected-type': type === fts.currentlySelectedType}">{{type.type.value | translatedb}}</div>
        </div>
        <div class="right">
          <div *ngFor="let subtype of fts.currentlySelectedType.subTypes" (click)="fts.toggleSelected(subtype, 'type')">
            <input type="checkbox" [(ngModel)]="subtype.isSelected"
                   [checked]="subtype.isSelected">{{subtype.value | translatedb}}</div>
        </div>
      </div>
    </div>
    <div class="input-selection-container">
      <div class="small-title">{{'PRICE' | translate}}</div>
      <div class="input-number"> {{'FROM' | translate | lowercase}}
        <input [(ngModel)]="fts.priceFrom" (change)="fts.filterOffers()">
        <div>€</div>
      </div>
      <div class="input-number"> {{'TO' | translate | lowercase}}
        <input [(ngModel)]="fts.priceTo" (change)="fts.filterOffers()">
        <div>€</div>
      </div>
    </div>
    <div class="input-selection-container">
      <div class="small-title">{{'SPACE' | translate}}</div>
      <div class="input-number"> {{'FROM' | translate | lowercase}}
        <input [(ngModel)]="fts.areaFrom" (change)="fts.filterOffers()">
        <div>м<sup>2</sup></div>
      </div>
      <div class="input-number"> {{'TO' | translate | lowercase}}
        <input [(ngModel)]="fts.areaTo" (change)="fts.filterOffers()">
        <div>м<sup>2</sup></div>
      </div>
    </div>
    <div class="input-selection-container">
      <div class="small-title">{{'SEARCH_OFFER_BY_ID' | translate}}</div>
      <div class="input-number"><input [(ngModel)]="fts.id" (change)="fts.filterOffers()"></div>
    </div>
    <div class="sales-or-rents">
      <div class="major-type" [ngClass]="{'selected': fts.salesSelected}"
           (click)="fts.toggleSales()">{{'SALES' | translate}}</div>
      <div class="major-type" [ngClass]="{'selected': fts.rentsSelected}"
           (click)="fts.toggleRents()">{{'RENTS' | translate}}</div>
    </div>
  </div>
  <div class="right-container">
    <div class="subtitle">{{fts.regionField.value | translatedb}}</div>
    <div class="regions-container">
      <div *ngFor="let region of fts.regions" [ngClass]="{'selected': region.isSelected}"
           (click)="fts.toggleSelected(region, 'region')">{{region.value | translatedb}}
      </div>
    </div>
  </div>
</div>
